<template>
    <router-link :to="`/profile/${person.id}`">
        <div class="person">
            <img class="portrait" :src="person.portrait"/>
            <div class="info">
                <div class="name">{{person.name}}</div>
                <div class="sub-name">{{person.name_jp}}</div>
                <div class="sub-name">{{person.name_en}}</div>
                <div class="sep"/>
                <div class="prop">
                    <div class="prop-label">생일</div>
                    <div class="prop-value">{{person.birthday}}</div>
                </div>
                <div class="prop">
                    <div class="prop-label">출생지</div>
                    <div class="prop-value">{{person.birthplace}}</div>
                </div>
                <div class="prop">
                    <div class="prop-label">입소일</div>
                    <div class="prop-value">{{person.entranceday}}</div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ["person"],
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';
.person {
    display: flex;
    padding: 5px 10px 5px 5px;
    align-items: flex-start;
    border: 2px dashed gray;
    color: $text-color;
    cursor: pointer;
    .portrait {
        background-color: rgb(167, 87, 87);
        min-width: 200px;
        min-height: 200px;
        width: 300px;
        height: 300px;
        margin-right: 10px;
        filter: grayscale(100%);
    }
    .sep {
        height: 1px;
        width: 100%;
        border-top: 2px solid gray;
        margin: 10px 0;
    }
}
.person:hover {
    border-color: black;
    .portrait {
        filter: grayscale(0%);
    }
    .sep {
        border-top: 2px solid rgb(167, 87, 87);
    }
}
.info {
    display: flex;
    flex: 1;
    align-items: flex-start;
    flex-direction: column;
}
.name {
    font-size: 32px;
    font-weight: 900;
}
.sub-name {
    font-size: 12px;
    color: #bbbbbb;
    line-height: 16px;
}
.prop {
    display: flex;
    align-content: center;
}
.prop-label {
    width: 80px;
    text-align: left;
    font-size: 14px;
    line-height: 28px;
}
.prop-value {
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
}
</style>


